import React from "react";
import { CBadge } from "@coreui/react";
import { ChatAvatar } from "./ChatAvatar";
import RiskPill from "../../common/RiskPill";
import { capitalizeText, getInitials } from "../../../util/helpers";
const ChatTile = ({
  name,
  risk,
  date,
  count,
  previewText,
  onClick,
  avatar = null,
}) => {
  return (
    <div className="chat-tile d-flex justify-content-start" onClick={onClick}>
      <img
        alt="User's avatar"
        src={
          avatar
            ? avatar
            : `https://placehold.co/70x70/f1f1f5/395E9D/?text=${getInitials(
                name
              )}`
        }
        style={{
          height: "50px",
          width: "56px",
          borderRadius: "100%",
          marginRight: "2%",
        }}
      />

      <div className="container-fluid" style={{ width: "100%" }}>
        <div className="d-flex" style={{ gap: "10px", display: "block" }}>
          <label>{capitalizeText(name)}</label>
          <RiskPill
            type={risk}
            icon_type="flag"
            icon_height="10px"
            icon_width="10px"
            icon_styles={{ marginTop: "4px", marginRight: "4px" }}
            styles={{ fontSize: "0.75rem" }}
          />
        </div>
        <small>
          <span>
            {previewText?.includes("chathistoryimages")
              ? "Sent an image"
              : previewText}
          </span>
        </small>
      </div>
      <div>
        <span style={{ display: "block" }}>{date}</span>
        <br />
        <div className="d-flex justify-content-end">
          <CBadge
            style={{
              color: "white",
              backgroundColor: "#2bc2f7",
              padding: "5px 10px",
            }}
            shape="rounded-circle"
          >
            {count !== 0 && count}
          </CBadge>
        </div>
      </div>
    </div>
  );
};

export default ChatTile;
